// Date 2025-05-27 10:31:09


import emEpcTagList from "@/views/em/epc/EmEpcTagList.vue";
import emEpcBindHisList from "@/views/em/epc/EmEpcBindHisList.vue";
import emEpcBindHisEdit from "@/views/em/epc/EmEpcBindHisEdit.vue";
import emEpcTagEdit from "@/views/em/epc/EmEpcTagEdit.vue";
import emEpcTagMaterialList from "@/views/em/epc/EmEpcTagMaterialList.vue";
import emEpcTagMaterialEdit from "@/views/em/epc/EmEpcTagMaterialEdit.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};


export default [
//公用组件注册
//自定义页面注册
    {
        path: "/em/epc/emEpcTagList",
        name: "emEpcTagList",
        component: emEpcTagList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/epc/emEpcTagEdit",
        name: "emEpcTagEdit",
        component: emEpcTagEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/epc/emEpcBindHisList",
        name: "emEpcBindHisList",
        component: emEpcBindHisList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/epc/emEpcBindHisEdit",
        name: "emEpcBindHisEdit",
        component: emEpcBindHisEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/epc/emEpcTagMaterialList",
        name: "emEpcTagMaterialList",
        component: emEpcTagMaterialList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/epc/emEpcTagMaterialEdit",
        name: "emEpcTagMaterialEdit",
        component: emEpcTagMaterialEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }
]
